import { FETCH_COUNTRY_REQUEST, FETCH_COUNTRY_SUCCESS, FETCH_COUNTRY_ERROR } from '../constants/ActionTypes';

export default function fetchCountryError(state = false, action) {
    switch (action.type) {
        case FETCH_COUNTRY_REQUEST:
        case FETCH_COUNTRY_SUCCESS:
            return false;
        case FETCH_COUNTRY_ERROR:
            return true;
        default:
            return state;
    }
}
